export default angular
  .module('doxy.common.services.authHelpers', [])
  .factory(
    'authHelpers',
    function (User, trackingFactory, Browser, UserLocationDetails) {
      async function login(extraData, post) {
        const locationInfo = await UserLocationDetails.getLocationDetails();
        return User.login(extraData, {
          ...post,
          ...Browser.getSystemInfo(),
          ...locationInfo,
        }).$promise.then(function (result) {
          trackingFactory.trackSignIn(result.user);
          return { ...result, ...locationInfo };
        });
      }

      return { login };
    }
  ).name;
